import React from "react";

interface MaintenanceModeProps {
  message?: string;
}

export const MaintenanceMode: React.FC<MaintenanceModeProps> = ({
  message = "System under maintenance. We'll be back soon!"
}) => {
  return (
    <div className="fixed inset-0 bg-gray-900 flex items-center justify-center">
      <div className="bg-gray-800 p-8 rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="text-center">
          {/* Maintenance Icon */}
          <div className="mb-6">
            <svg
              className="w-24 h-24 mx-auto text-orange-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          <h1 className="text-2xl font-bold text-white mb-4">Maintenance Mode</h1>

          <p className="text-gray-300 mb-6">{message}</p>

          <div className="mt-8">
            <button
              onClick={() => window.location.reload()}
              className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-6 rounded transition-colors duration-200"
            >
              Check Again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
